import { defineNuxtPlugin } from 'nuxt/app'

import { createI18nLoader, getMergedLayerLocales } from '@plugins/i18n-loader'

/**
 * Load layer locales for clientportal app.
 * Add new domains by adding new glob patterns below.
 */
const getLayerLocales = () => ({
  ...(import.meta as any).glob('../../../libs/layers/common/*/locales/*.json', { eager: true }),
  ...(import.meta as any).glob('../../../libs/layers/account-settings/*/locales/*.json', {
    eager: true,
  }),
  ...(import.meta as any).glob('../../../libs/layers/courses/*/locales/*.json', { eager: true }),
  ...(import.meta as any).glob('../../../libs/layers/communities/*/locales/*.json', {
    eager: true,
  }),
  ...(import.meta as any).glob('../../../libs/layers/clientportal/*/locales/*.json', {
    eager: true,
  }),
  ...(import.meta as any).glob('../../../libs/layers/loyalty/*/locales/*.json', {
    eager: true,
  }),
  // Add new domains here:
  // ...(import.meta as any).glob('../../../libs/layers/billing/*/locales/*.json', { eager: true }),
  // ...(import.meta as any).glob('../../../libs/layers/notifications/*/locales/*.json', { eager: true }),
})

/**
 * Get merged layer locales for a specific locale.
 * Used by test setup to get translations for the test environment.
 */
export const getMergedLayerLocalesForClientportal = (locale: string): Record<string, unknown> => {
  return getMergedLayerLocales(getLayerLocales, locale)
}

export default defineNuxtPlugin(
  createI18nLoader({
    getLayerLocales,
    useStructuredLogging: false,
  })
)
